import { Injectable, Injector } from '@angular/core';
import { MescService } from '../mesc/mesc.service'
import { utilities } from '../../../modules/utility';
import { mescServicesUrl, workflowServerUrl } from '../../../config/config.base';


export abstract class CamtlService {

}

@Injectable()
export class CamtlBaseService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl"); }
}


@Injectable()
export class ContactService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/Contact"); }
}


@Injectable()
export class FunctionContactService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/Contact/Function"); }
}


@Injectable()
export class FunctionService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/Function"); }
}

@Injectable()
export class FunctionTypeService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/FunctionType"); }
}

@Injectable()
export class DateTemplateService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/DateTemplate"); }
}


@Injectable()
export class DateTemplateSystemPhaseService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/DateTemplate"); }
}


@Injectable()
export class SystemPhaseDetailService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/SystemPhaseDetail"); }
}


@Injectable()
export class SystemPhaseService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/SystemPhase"); }
}


@Injectable()
export class SystemTimingControlDatesService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/SystemTimingControlDates"); }
}


@Injectable()
export class FunctionalViewSystemPhaseService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/FunctionalViewSystemPhaseService"); }
}


@Injectable()
export class FunctionalViewService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/FunctionalView"); }
}


@Injectable()
export class ProgramFunctionContactService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/ProgramContact"); }
}


@Injectable()
export class ZoneFunctionContactService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/SystemContact"); }
}


@Injectable()
export class SourceFunctionContactService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/SourceContact"); }
}


@Injectable()
export class FunctionTypeContactService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/Contact/functionType"); }
}


@Injectable()
export class ProgramAnalystService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/Contact/functionType/3"); }
}


@Injectable()
export class ProjectFunctionContactService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/Contact/Project"); }
}


@Injectable()
export class SourceContactService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/SourceContact"); }
}


@Injectable()
export class ProgramTaskService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/ProgramTask"); }
}


@Injectable()
export class ProgramTaskDetailById extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/ProgramDetail"); }
}

@Injectable()
export class ProgramTaskDetailService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/Program/TaskDetail"); }
}



@Injectable()
export class ProjectService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/Project"); }
}


@Injectable()
export class SourceService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/Source"); }
}

@Injectable()
export class ProductionSourceService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/Source"); }
}

@Injectable()
export class ConstructionSourceService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/Source/constructionsource"); }
}

@Injectable()
export class IntegrationSourceService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/Source/integrationsource"); }
}

@Injectable()
export class SystemService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/System"); }
}


@Injectable()
export class SystemAllocationStatusService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/SystemAllocationStatus"); }
}


@Injectable()
export class SystemSourceService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/SystemSourceHour"); }
}

@Injectable()
export class SystemEstimationLevelService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/SystemEstimationLevel"); }
}


@Injectable()
export class ToolService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/Tool"); }
}


@Injectable()
export class ToolChildrenService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/Tool/children"); }
}


@Injectable()
export class SystemByProgramService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/program"); }
}


@Injectable()
export class TimingChartControlService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/TimingChart"); }
}


@Injectable()
export class ToolNumberService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/Tool"); }
}

@Injectable()
export class ToolDescriptionByTypeService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/toolType"); }
}

@Injectable()
export class ToolDescriptionService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/toolDescription/"); }
}


@Injectable()
export class PlantOccurrenceService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/Tool/plantOccurance/"); }
}


@Injectable()
export class ParallelProcessService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/CellParallelProcess/"); }
}


@Injectable()
export class KitService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/Kit"); }
}


@Injectable()
export class KitDescriptionService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/KitDescription/"); }
}

@Injectable()
export class CellService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/Tool"); }
}

@Injectable()
export class StationService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/Tool"); }
}

@Injectable()
export class SystemStatusService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/SystemStatus"); }
}

@Injectable()
export class ToolTypeService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/tool/toolType"); }
}


@Injectable()
export class ControlPanelService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/ControlPanel"); }
}

@Injectable()
export class ControlPanelServiceDescription extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/controlpanel/description"); }
}

@Injectable()
export class KitServiceDescription extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/KitDescription"); }
}




@Injectable()
export class ToolTypeDescriptionService extends MescService {
    constructor(injector: Injector) { super(injector, "camtl/toolDescription/"); }
}

@Injectable()
export class WorkflowInboxService extends MescService {
    constructor(injector: Injector) {
        super(injector, "camtl/requestprocess/inbox");
        this.BASE_URL = mescServicesUrl[utilities.getEnv()];
    }
}

@Injectable()
export class WorkflowStartService extends MescService {
    constructor(injector: Injector) {
        super(injector, "camtl/requestprocess/start");
        this.BASE_URL = mescServicesUrl[utilities.getEnv()];
    }
}

@Injectable()
export class WorkflowApprovalService extends MescService {
    constructor(injector: Injector) {
        super(injector, "camtl/requestprocess/approval");
        this.BASE_URL = mescServicesUrl[utilities.getEnv()];
    }
}

@Injectable()
export class WorkflowTaskService extends MescService {
    constructor(injector: Injector) {
        super(injector, "WFTask");
        this.BASE_URL = workflowServerUrl[utilities.getEnv()];
    }
}

@Injectable()
export class RequestProcessService extends MescService {
    constructor(injector: Injector) {
        super(injector, "camtl/requestprocess");
        this.BASE_URL = mescServicesUrl[utilities.getEnv()];
    }
}

@Injectable()
export class ReportService extends MescService {
    constructor(injector: Injector) { super(injector, "report"); }
}